import React from "react";
import { isMobile } from "helpers/Mobile";
import AppTableItem from "./AppTableItem";
import Icon from "components/MainApp/atoms/Icon/icon";

import styles from "./AppTable.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const AppTable = ({ apps, totalItems, headers, handleClickApp }) => {
  const renderHeaderItem = (header) => {
    return (
      <div
        data-automation-id={`sort-by-${header.name}`}
        // onClick={() => {
        //   headerClickHandler(header.name);
        // }}
        data-filter-name={header.name}
        className={`${styles["app-table-header-item"]} ${styles[`app-table-header-${header.name}`]}`}
        key={header.name}
      >
        {header.title}
        {/* <span className={`app-table-header-icon-span ${header.active ? "active" : ""}  ${header.direction ? "" : "down"}`}> <i className="icon-iconos_flecha-ordenar"></i></span> */}
      </div>
    );
  };
  const table = (
    <React.Fragment>
      <div className={styles["app-table-total"]}>
        {capitalize(i18n.t("total"))} <span>({totalItems})</span>
      </div>
      <div className={styles["app-table-desktop"]} data-automation-id="apps-table">
        {!isMobile && (
          <div className={styles["app-table-header"]}>
            {headers.map((header) => renderHeaderItem(header))}

            <div className={`${styles["app-table-header-item"]} ${styles["app-table-header-button"]}`}></div>
          </div>
        )}
        <div className={styles["app-table-content"]}>
          {apps?.map((app) => {
            return (
              <div className={styles["app-table-content-item"]} key={app.id}>
                <AppTableItem app={app} handleClick={handleClickApp} />
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );

  const noitems = (
    <div className={styles["app-table-no-items"]}>
      <Icon name="apps" fill="#3C7AF5" width={87} height={65}></Icon>
      <h1>{i18n.t("no.results")}</h1>
    </div>
  );

  return (
    <div className={styles["app-table-container"]}>
      {apps.length > 0 ? table : noitems}
    </div>
  );
};

export default AppTable;
